/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Button,
  Nav,
  Navbar,
  Offcanvas,
  Card,
  Row,
  Col,
  // Dropdown
} from "react-bootstrap";

import { Link, useNavigate } from "react-router-dom";
import {
  CommonButton,
  ImageElement,
  ModalComponent,
  RippleEffect,
  // Upload,
  Checkbox,
} from "components";

import { Link as ScrollLink } from "react-scroll";
import routesMap from "routeControl/userRouteMap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Select, Upload } from "antd";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Autoplay, Pagination } from "swiper/modules";
import { getSessionStorage, setSessionStorage } from "utils";

/* eslint-disable */

function Theme01() {
  const [isActive, setIsActive] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const oneSubscriptionData = getSessionStorage("oneSubscriptionData");

  const navigate = useNavigate();
  const path = {
    1: `${routesMap?.LAYOUTFOUR?.path}/${1}`,
    4: `${routesMap?.LAYOUTFOUR?.path}/${4}`,
    3: routesMap?.LAYOUTTHREE?.path,
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setIsActive(false);
    };
    handleResize();
    // Add event listener for window resize
    window.addEventListener("resize", handleResize);
    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount
  const toggleClass = () => {
    if (windowWidth <= 991) {
      setIsActive(!isActive);
    }
  };
  const handleClose = () => {
    setIsActive(false);
  };
  /* image modal */
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const openImageModal = () => {
    setShowModal(!showModal);
  };

  /* image slider modal */
  const [showModal1, setShowModal1] = useState(false);
  const handleCloseModal1 = () => {
    setShowModal1(false);
  };
  const openImageModal1 = () => {
    setShowModal1(!showModal1);
  };

  const [leftPadding, setLeftPadding] = useState();
  // Add and Remove Class on scroll
  const [scrolltopdata, setscrolltopdata] = useState("");
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY < 50) {
        setscrolltopdata("");
      } else {
        setscrolltopdata("navbar_scroll");
      }
    });
    const handleResize = () => {
      const containerOffset = document
        .querySelector(".testimonials .container")
        .getBoundingClientRect();
      const newLeftPadding = containerOffset.left + 15;
      setLeftPadding(newLeftPadding);
    };
    handleResize();
    window.addEventListener("load", handleResize);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("load", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  //  header click section redirect function
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    let navbarMenu = document.querySelector(
      ".theme01Header .navbar"
    ).clientHeight;
    setOffset(navbarMenu);
  }, [window.scroll]);

  const [navbarShow, setNavbarShow] = useState(false);
  const handleNavClose = () => setNavbarShow(false);
  const handleNavShow = () => setNavbarShow(true);

  /* memeories video modal */
  const [showVideoModal, setVideoModal] = useState(false);
  const handleCloseModalVideo = () => {
    setVideoModal(false);
  };
  /* memeories full video modal */
  const [showVideoFullModal, setVideoFullModal] = useState(false);
  const handleCloseModalVideoFull = () => {
    setVideoFullModal(false);
    setVideoModal(true);
  };
  const handleVideoFullShow = () => {
    setVideoFullModal(true);
    setVideoModal(false);
  };
  /* memeories full image modal */
  const [showImageFullModal, setImageFullModal] = useState(false);
  const handleCloseModalImageFull = () => {
    setImageFullModal(false);
    setVideoModal(true);
  };
  const handleImageFullShow = () => {
    setImageFullModal(true);
    setVideoModal(false);
  };
  /* memeories audio modal */
  const [showAudioModal, setAudioModal] = useState(false);
  const handleCloseModalAudio = () => {
    setAudioModal(false);
  };
  /* memeories pdf modal */
  const [showPdfModal, setPdfModal] = useState(false);
  const handleCloseModalPdf = () => {
    setPdfModal(false);
  };

  /* SHare Modal */
  const [shareModal, setShareModal] = useState(false);
  const handleCloseModalShare = () => {
    setShareModal(false);
  };
  const [commentModal, setCommentModal] = useState(false);
  const handleCloseModalComment = () => {
    setCommentModal(false);
  };
  /* report modal */
  const [showReportModal, setReportModal] = useState(false);
  const handleCloseModalReport = () => {
    setReportModal(false);
  };



  const Navigation = () => {
    console.log("oneSubscriptionData", oneSubscriptionData);
    if (oneSubscriptionData && oneSubscriptionData?.memorialId === null) {
      navigate(path?.[oneSubscriptionData?.subscription?.layout]);
      setSessionStorage("oneSubscriptionData", oneSubscriptionData);
    } else {
      navigate(routesMap?.CHOOSE_PLAN?.path);
    }
  };

  // Family Tree
  const nodeBinding = {
    userImage: "img",
    userName: "name",
    userRelation: "relation",
    userBirth: "born",
  };

  const data = [
    {
      id: 1,
      pids: [2],
      name: "Terry D. Williams",
      gender: "male",
      img: "assets/images/frontend/family-tree/user01.jpg",
      relation: "Grand Father",
      born: "May 1951 -Dec 2022",
      tags: ["userInfo"],
    },
    {
      id: 2,
      pids: [1],
      name: "Jessica Williams",
      gender: "female",
      img: "assets/images/frontend/family-tree/user02.jpg",
      relation: "Grand Mother",
      born: "Dec 1958",
    },
    {
      id: 3,
      mid: 1,
      fid: 2,
      pids: [4],
      name: "Jessica Williams",
      gender: "male",
      img: "assets/images/frontend/family-tree/user03.jpg",
      relation: "Father",
      born: "Dec 15, 1968",
      tags: ["userInfo"],
    },
    {
      id: 4,
      pids: [3],
      name: "Terry D. Williams",
      gender: "female",
      img: "assets/images/frontend/family-tree/user06.jpg",
      relation: "Mother",
      born: "Dec 15, 1966",
    },
    {
      id: 5,
      mid: 3,
      fid: 4,
      name: "William",
      gender: "male",
      img: "assets/images/frontend/family-tree/user09.jpg",
      relation: "Brother's Son",
      born: "January 11, 2020",
    },
    {
      id: 6,
      pids: [7],
      name: "Jessica Williams",
      gender: "male",
      img: "assets/images/frontend/family-tree/user08.jpg",
      relation: "Uncle",
      born: "Dec 15, 1968",
      tags: ["userInfo"],
    },
    {
      id: 7,
      mid: 2,
      fid: 1,
      pids: [6],
      name: "D. Williams",
      gender: "female",
      img: "assets/images/frontend/family-tree/user04.jpg",
      relation: "Aunt",
      born: "May 1951 -Dec 2022",
      tags: ["userInfo"],
    },
    {
      id: 8,
      mid: 1,
      fid: 2,
      name: "Kenneth A. Moore",
      gender: "male",
      img: "assets/images/frontend/family-tree/user05.jpg",
      relation: "Uncle",
      born: "May 1965 -Jan 2000",
      tags: ["userInfo"],
    },
    {
      id: 9,
      mid: 7,
      fid: 6,
      name: "Evelyn  ",
      gender: "female",
      img: "assets/images/frontend/family-tree/user10.jpg",
      relation: "Daughter",
      born: "June 24, 2018",
    },
    {
      id: 10,
      mid: 7,
      fid: 6,
      name: "Thomas ",
      gender: "male",
      img: "assets/images/frontend/family-tree/user11.jpg",
      relation: "Son",
      born: "October 18, 2009",
    },
  ];

  const videoMemories = [
    {
      id: 1,
      name: "Friendship Chronicles",
      duration: "08:45",
      thumbnail: "modal-video-01.webp",
      alt: "",
      imageShow: false,
      videoDuration: true,
      videoIcon: true,
      imageIcon: false,
    },
    {
      id: 2,
      name: "Love & Relationships",
      duration: "08:45",
      thumbnail: "modal-video-02.webp",
      imageShow: true,
      videoDuration: false,
      videoIcon: false,
      imageIcon: true,
    },
    {
      id: 3,
      name: "Adventures in Youth",
      duration: "08:45",
      thumbnail: "modal-video-03.webp",
      imageShow: true,
      videoDuration: false,
      videoIcon: false,
      imageIcon: true,
    },
    {
      id: 4,
      name: "Innocence Unveiled",
      duration: "08:45",
      thumbnail: "modal-video-04.webp",
      imageShow: false,
      videoDuration: true,
      videoIcon: true,
      imageIcon: false,
    },
    {
      id: 5,
      name: "Teenage Dreams",
      duration: "08:45",
      thumbnail: "modal-video-05.webp",
      imageShow: false,
      videoDuration: true,
      videoIcon: true,
      imageIcon: false,
    },
    {
      id: 6,
      name: "Friendship Chronicles",
      duration: "08:45",
      thumbnail: "modal-video-06.webp",
      imageShow: false,
      videoDuration: true,
      videoIcon: true,
      imageIcon: false,
    },
  ];
  const audioMemories = [
    {
      id: 1,
      name: "Friendship Chronicles",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 2,
      name: "Journey of Love",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 3,
      name: "Innocence Unveiled",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 4,
      name: "Adventures in Youth",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 5,
      name: "Friendship Chronicles",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 6,
      name: "Journey of Love",
      audioUrl: "",
      duration: "09:45",
    },
  ];
  /* PDF Modal Select */
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [individualCheckboxes, setIndividualCheckboxes] = useState(
    Array(6).fill(false)
  );
  const handleCheckboxChange = (index) => {
    const updatedCheckboxes = [...individualCheckboxes];
    updatedCheckboxes[index] = !updatedCheckboxes[index];
    setIndividualCheckboxes(updatedCheckboxes);
    const allChecked = updatedCheckboxes.every((checkbox) => checkbox);
    setSelectAllChecked(allChecked);
  };
  const handleSelectAll = () => {
    const allChecked = !selectAllChecked;
    setSelectAllChecked(allChecked);
    setIndividualCheckboxes(Array(6).fill(allChecked));
  };
  /* audio Modal Select */
  const [selectAllCheckedAudio, setSelectAllCheckedAudio] = useState(false);
  const [individualCheckboxesAudio, setIndividualCheckboxesAudio] = useState(
    Array(6).fill(false)
  );
  const handleCheckboxChangeAudio = (index) => {
    const updatedCheckboxesAudio = [...individualCheckboxesAudio];
    updatedCheckboxesAudio[index] = !updatedCheckboxesAudio[index];
    setIndividualCheckboxesAudio(updatedCheckboxesAudio);
    const allCheckedAudio = updatedCheckboxesAudio.every(
      (checkbox) => checkbox
    );
    setSelectAllCheckedAudio(allCheckedAudio);
  };
  const handleSelectAllAudio = () => {
    const allCheckedAudio = !selectAllCheckedAudio;
    setSelectAllCheckedAudio(allCheckedAudio);
    setIndividualCheckboxesAudio(Array(6).fill(allCheckedAudio));
  };
  /* video Modal Select */
  const [selectAllCheckedVideo, setSelectAllCheckedVideo] = useState(false);
  const [individualCheckboxesVideo, setIndividualCheckboxesVideo] = useState(
    Array(6).fill(false)
  );
  const handleCheckboxChangeVideo = (index) => {
    const updatedCheckboxesVideo = [...individualCheckboxesVideo];
    updatedCheckboxesVideo[index] = !updatedCheckboxesVideo[index];
    setIndividualCheckboxesVideo(updatedCheckboxesVideo);
    const allCheckedVideo = updatedCheckboxesVideo.every(
      (checkbox) => checkbox
    );
    setSelectAllCheckedVideo(allCheckedVideo);
  };
  const handleSelectAllVideo = () => {
    const allCheckedVideo = !selectAllCheckedVideo;
    setSelectAllCheckedVideo(allCheckedVideo);
    setIndividualCheckboxesVideo(Array(6).fill(allCheckedVideo));
  };

  // ********************* Family tree functions *************************//
  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    isFullscreen
      ? document.exitFullscreen()
      : document.documentElement.requestFullscreen();
    setIsFullscreen((prevState) => !prevState);
  };
  if (document.addEventListener) {
    document.addEventListener("fullscreenchange", exitHandler, false);
    document.addEventListener("mozfullscreenchange", exitHandler, false);
    document.addEventListener("MSFullscreenChange", exitHandler, false);
    document.addEventListener("webkitfullscreenchange", exitHandler, false);
  }
  function exitHandler() {
    if (
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      setIsFullscreen(false);
    }
  }

  let tree = document.querySelector(".parent");
  let eleWidth = document.querySelector(".tree");
  let screenWidthOut = eleWidth?.offsetWidth;
  let treeWidthOut = tree?.offsetWidth;
  let isDragging = false;
  let startX;
  let startY;
  let startLeft;
  let startTop;
  let zoomValue;
  if (treeWidthOut > screenWidthOut) {
    zoomValue = screenWidthOut / treeWidthOut;
  } else {
    zoomValue = 1;
  }
  function fitToScreen() {
    let screenWidth = eleWidth?.offsetWidth;
    let treeWidth = tree?.offsetWidth;
    if (treeWidth > screenWidth) {
      let scale = screenWidth / treeWidth;
      zoomValue = scale;
      if (tree) {
        tree.style.transform = `scale(${scale})`;
      }
      tree.style.top = "auto";
      tree.style.left = "auto";
    } else {
      if (tree) {
        tree.style.transform = "scale(1)";
        tree.style.top = "auto";
        tree.style.left = "auto";
      }
    }
  }

  function zoomIn() {
    if (zoomValue < 2) {
      zoomValue += 0.1;
      tree.style.transform = `scale(${zoomValue})`;
    }
  }
  function zoomOut() {
    if (zoomValue > 0.16) {
      zoomValue -= 0.1;
      tree.style.transform = `scale(${zoomValue})`;
    }
  }
  tree?.addEventListener("mousedown", function (event) {
    isDragging = true;
    startX = event.clientX;
    startY = event.clientY;
    startLeft = parseInt(tree?.style.left) || 0;
    startTop = parseInt(tree?.style.top) || 0;
    tree.classList.add("noselect");
    tree.style.cursor = "grabbing";
  });
  tree?.addEventListener("touchstart", function (event) {
    isDragging = true;
    const touchLocation = event.targetTouches[0];
    startX = touchLocation.pageX;
    startY = touchLocation.pageY;
    startLeft = parseInt(tree?.style.left) || 0;
    startTop = parseInt(tree?.style.top) || 0;
    tree.classList.add("noselect");
    tree.style.cursor = "grabbing";
  });

  document.addEventListener("mouseup", function () {
    isDragging = false;
    if (tree) {
      tree.classList.remove("noselect");
      tree.style.cursor = "grab";
    }
  });
  document.addEventListener("touchend", function () {
    isDragging = false;
    if (tree) {
      tree.classList.remove("noselect");
      tree.style.cursor = "grab";
    }
  });

  document.addEventListener("mousemove", function (event) {
    if (isDragging) {
      let offsetX = event.clientX - startX;
      let offsetY = event.clientY - startY;
      if (tree) {
        tree.style.left = `${startLeft + offsetX}px`;
        tree.style.top = `${startTop + offsetY}px`;
      }
    }
  });
  document.addEventListener("touchmove", function (event) {
    if (isDragging) {
      const touchLocation = event.targetTouches[0];
      let offsetX = touchLocation.pageX - startX;
      let offsetY = touchLocation.pageY - startY;
      if (tree) {
        tree.style.left = `${startLeft + offsetX}px`;
        tree.style.top = `${startTop + offsetY}px`;
      }
    }
  });
  tree?.addEventListener("wheel", function (event) {
    event.preventDefault();
    if (event.deltaY < 0) {
      zoomIn();
    } else {
      zoomOut();
    }
  });
  tree?.addEventListener(
    "gestureend",
    function (e) {
      e.preventDefault();
      if (e.scale < 1.0) {
        zoomOut();
      } else if (e.scale > 1.0) {
        zoomIn();
      }
    },
    false
  );
  window.addEventListener("resize", fitToScreen);
  useEffect(() => {
    fitToScreen();
  }, [tree]);

  const treeHeightRef = useRef(null);
  useEffect(() => {
    if (treeHeightRef.current) {
      const treeHeight = treeHeightRef.current.offsetHeight;
      let sheet = document.styleSheets[0];
      sheet.insertRule(`:root{--treeHeightRef:${treeHeight}px}`);
    }
  }, []);

  return (
    <>
      {/* Header Start */}
      <header className="theme01Header">
        <Navbar fixed="top" expand={false} className={`${scrolltopdata}`}>
          <Container className="d-block">
            <div className="d-flex align-items-center justify-content-between">
              <Navbar.Brand
                href={routesMap.USERDASHBOARD.path}
                className="navbar-brand flex-grow-1 flex-lg-grow-0 p-0"
              >
                <ImageElement
                  source="theme-logo.svg"
                  className="lightLogo"
                  alt="logo"
                />

                <ImageElement
                  source="logo.svg"
                  className="darkLogo"
                  alt="logo"
                />
              </Navbar.Brand>
              <Navbar.Offcanvas
                show={navbarShow}
                onHide={handleNavClose}
                placement="end"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>MENU</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="p-0">
                  <Nav className="my-md-auto mb-auto pe-2 navbar-nav">
                    <ScrollLink
                      activeClass="active"
                      className="nav-link"
                      to="about"
                      spy
                      smooth
                      offset={-offset}
                      duration={800}
                      onClick={handleNavClose}
                    >
                      <span>
                        About
                        <em className="icon-arrow-right" />
                      </span>
                    </ScrollLink>
                    <ScrollLink
                      activeClass="active"
                      className="nav-link"
                      to="gallery"
                      spy
                      smooth
                      offset={-offset}
                      duration={800}
                      onClick={handleNavClose}
                    >
                      <span>
                        Gallery
                        <em className="icon-arrow-right" />
                      </span>
                    </ScrollLink>
                    <ScrollLink
                      activeClass="active"
                      className="nav-link"
                      to="timeline"
                      spy
                      smooth
                      offset={-offset}
                      duration={800}
                      onClick={handleNavClose}
                    >
                      <span>
                        Timeline
                        <em className="icon-arrow-right" />
                      </span>
                    </ScrollLink>
                    <ScrollLink
                      activeClass="active"
                      className="nav-link"
                      to="story"
                      spy
                      smooth
                      offset={-offset}
                      duration={800}
                      onClick={handleNavClose}
                    >
                      <span>
                        Story
                        <em className="icon-arrow-right" />
                      </span>
                    </ScrollLink>
                    <ScrollLink
                      activeClass="active"
                      className="nav-link"
                      to="familytree"
                      spy
                      smooth
                      offset={-offset}
                      duration={800}
                      onClick={handleNavClose}
                    >
                      <span>
                        Family Tree
                        <em className="icon-arrow-right" />
                      </span>
                    </ScrollLink>
                  </Nav>
                  <ul className="list-unstyled d-flex social flex-shrink-0 position-relative">
                    <li>
                      <Link> Instagram</Link>
                      <span>|</span>
                    </li>
                    <li>
                      <Link> Twitter</Link>
                      <span>|</span>
                    </li>

                    <li>
                      <Link> Facebook</Link>
                    </li>
                  </ul>
                </Offcanvas.Body>
              </Navbar.Offcanvas>

              <div className="d-flex align-items-center justify-content-between">
                <Navbar.Toggle
                  aria-controls="basic-navbar-nav"
                  className=" menuIcon border-0 p-0 h-auto bg-transparent"
                  onClick={handleNavShow}
                >
                  <em className="icon-menu" />
                </Navbar.Toggle>
                <RippleEffect extraClassName="btnCenter">
                  <CommonButton variant="outline-white" size="sm">
                    <em className="icon-saved me-sm-2" />
                    <span className="d-none d-sm-block">Save</span>
                  </CommonButton>
                </RippleEffect>
                <RippleEffect  extraClassName="btnCenter ms-0">
                  <CommonButton variant="danger" size="sm">
                    <em className="icon-share me-sm-2" />
                    <span className="d-none d-sm-block">Share</span>
                  </CommonButton>
                </RippleEffect>
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    Navigation();
                  }}
                  className="btn btn-white btn-sm"
                >
                  <em className="icon-arrow-prev me-sm-2" />
                  <span className="d-none d-sm-block">Back</span>
                </Link>
                {/* Button for theme privew case */}
                {/* <RippleEffect extraClassName="ms-xxl-4 ms-sm-3 ms-2">
                  <CommonButton
                    variant="outline-white"
                    size="sm"
                  >
                    <em className="icon-arrow-prev me-sm-2" />
                    <span className="d-none d-sm-block">Back</span>
                  </CommonButton>
                  </RippleEffect>
                  <RippleEffect extraClassName="ms-xxl-4 ms-sm-3 ms-2">
                  <CommonButton
                    variant="danger"
                    size="sm"
                  >
                    <span>Create<span className="d-none d-sm-inline-block"> a Memorial</span></span>
                  </CommonButton>
                </RippleEffect> */}
                {/* Button for theme privew case close */}

                {/* <Dropdown className="d-flex justify-content-center align-items-center actionDropdown btnCenter">
                      <Dropdown.Toggle variant="outline-white" className="btn-sm">
                            <span className="d-none d-sm-block">Action</span>
                            <em className="icon-dots d-block d-sm-none" />
                            <em className="icon-arrow-down ms-sm-2 d-none d-sm-block" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="border-0 p-0">
                        <Dropdown.Item href="#/action-1" className="d-flex align-items-center">
                        <em className="icon-edit me-2" /> Edit
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-1" className="d-flex align-items-center">
                        <em className="icon-saved me-2" /> Save as Draft
                        </Dropdown.Item>
                      </Dropdown.Menu>
                  </Dropdown>
                <RippleEffect>
                  <CommonButton
                    className="w-auto"
                    variant="danger"
                    size="sm"
                  >
                    <span>Publish

                    </span>
                  </CommonButton>
                </RippleEffect>   */}
              </div>
            </div>
          </Container>
        </Navbar>
      </header>
      {/* Header End */}
      <main className="theme01Page">
        {/* Banner Start */}
        <section className="banner position-relative overflow-hidden">
          <ImageElement
            source="theme01/banner.webp"
            className="w-100 h-100 object-fit-cover"
            alt="banner"
          />
        </section>
        {/* Banner End */}

        {/* About Section Start */}
        <section className="aboutSec position-relative py-80 pt-0" id="about">
          <Container>
            <div className="d-md-flex">
              <div className="aboutSec_left w-100 flex-shrink-0">
                <ImageElement
                  source="theme01/about-img.webp"
                  className="img-fluid w-100 d-block"
                  alt="about-image"
                />
                <div className="aboutSec_left_inner">
                  <div className="aboutSec_subTitle mb-0 text-center text-md-start">
                    About
                  </div>
                  <ul className="list-unstyled mb-0">
                    <li className="d-flex">
                      <span className="flex-shrink-0">Born:</span> 17 September
                      1970 (age 33 years)
                    </li>
                    <li className="d-flex">
                      <span className="flex-shrink-0">Birth Place:</span>Los
                      Angeles, United States
                    </li>
                    <li className="d-flex">
                      <span className="flex-shrink-0">Spouse: </span> Ronnie S.
                      Bodiford (m. 2015)
                    </li>
                    <li className="d-flex">
                      <span className="flex-shrink-0">Children:</span> Maddox
                      Chivan Jolie-Pitt, Pax Thien Jolie-Pitt
                    </li>
                    <li className="d-flex">
                      <span className="flex-shrink-0">Parents:</span> Jon D.
                      Mills, Roberta J. Mills
                    </li>
                    <li className="d-flex">
                      <span className="flex-shrink-0">Siblings:</span> Roland D.
                      Mills
                    </li>
                  </ul>
                </div>
              </div>
              <div className="aboutSec_right">
                <div className="aboutSec_right_head">
                  <h1 className="aboutSec_title text-white mb-2">
                    Margarita R. Proffitt
                  </h1>
                  <div className="txt">Jan 10, 1970 - Aug 12, 2024</div>
                  <span className="d-flex align-items-center txt">
                    <em className="icon-location" />
                    Los Angeles, US
                  </span>
                  {/* Social Icons */}
                  <div className="d-flex justify-content-between align-items-end">
                    <ul className="list-inline mb-0 aboutSec_social flex-shrink-0">
                      <li className="list-inline-item">
                        <Link
                          aria-label="instagram"
                          to="#"
                          className="d-flex align-items-center justify-content-center aboutSec_social_icon"
                        >
                          <em className="icon-instagram" />
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          aria-label="twitter"
                          to="#"
                          className="d-flex align-items-center justify-content-center aboutSec_social_icon"
                        >
                          <em className="icon-twitter" />
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          aria-label="facebook"
                          to="#"
                          className="d-flex align-items-center justify-content-center aboutSec_social_icon"
                        >
                          <em className="icon-facebook" />
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          aria-label="report"
                          to="#"
                          className="d-flex align-items-center justify-content-center aboutSec_social_icon"
                          onClick={() => setReportModal(true)}
                        >
                          <em className="icon-report" />
                        </Link>
                      </li>
                    </ul>

                    {/* <RippleEffect
                        extraClassName="justify-content-end"
                      >
                        <Button className="btn btn-sm btnDownload">
                          <em className="icon-download me-sm-2" />
                          <span className="d-none d-sm-block">Download</span>
                        </Button>
                      </RippleEffect> */}
                  </div>
                </div>
                <div className="aboutSec_right_body">
                  <h2 className="aboutSec_subTitle mb-0">Biography</h2>
                  <p className="mb-0">
                    Margarita Rose Proffitt, a luminary born into the world on
                    the balmy afternoon of September 19, 1990, brought her
                    unique brilliance to every corner of life. From her early
                    days in the vibrant city of Harmonyville, Margarita
                    demonstrated an indomitable spirit and an unwavering
                    commitment to spreading joy.
                  </p>
                  <p className="mb-0">
                    Margarita's journey began against the backdrop of a world
                    transitioning into the digital age. As a child, she embraced
                    the wonders of technology, showcasing a natural flair for
                    innovation that hinted at the remarkable woman she would
                    become. Friends and family fondly recall her insatiable
                    curiosity, often finding her immersed in books or tinkering
                    with gadgets, driven by an innate desire to understand and
                    contribute to the rapidly evolving world around her.
                  </p>
                  <p className="mb-0">
                    Graduating with honors from Harmonyville High School,
                    Margarita continued her academic pursuits at the prestigious
                    Harmonyville University. There, she excelled not only in her
                    studies but also in cultivating meaningful connections with
                    peers who admired her intelligence, compassion, and sense of
                    humor.
                  </p>
                </div>
              </div>
            </div>
          </Container>
          <div className="downloadSec">
            <Container>
              <div className="downloadSec_inner rounded-0 brd">
                <Row className="justify-content-md-between">
                  <Col xxl={2} md={3} sm={4} xs={6}>
                    <div className="storyCard storyCard-theme01">
                      <div
                        className="storyCard_img position-relative storyCard_img-audio cursor-pointer"
                        onClick={() => setAudioModal(true)}
                      >
                        <div className="storyCard_btn position-absolute d-flex justify-content-center align-items-center">
                          <em className="icon-mic" />
                        </div>
                      </div>
                      <h2 className="storyCard_txt text-center mb-0">Audio</h2>
                    </div>
                  </Col>
                  <Col xxl={2} md={3} sm={4} xs={6}>
                    <div className="storyCard storyCard-theme01">
                      <div
                        className="storyCard_img position-relative storyCard_img-image cursor-pointer"
                        onClick={() => setVideoModal(true)}
                      >
                        <div className="image">
                          <ImageElement
                            className="img-fluid w-100 h-100 object-fit-cover"
                            source="downloadable-img .webp"
                          />
                        </div>
                        <div className="storyCard_btn position-absolute d-flex justify-content-center align-items-center">
                          <em className="icon-img-video" />
                        </div>
                      </div>
                      <h2 className="storyCard_txt text-center mb-0">
                        Image & Video
                      </h2>
                    </div>
                  </Col>
                  <Col xxl={2} md={3} sm={4} xs={6}>
                    <div className="storyCard storyCard-theme01">
                      <div
                        className="storyCard_img position-relative storyCard_img-pdf cursor-pointer"
                        onClick={() => setPdfModal(true)}
                      >
                        <div className="storyCard_btn position-absolute d-flex justify-content-center align-items-center">
                          <em className="icon-pdf" />
                        </div>
                      </div>
                      <h2 className="storyCard_txt text-center mb-0">PDF</h2>
                    </div>
                  </Col>
                  <Col xxl={4} md={3} sm={6} xs={6}>
                    <div className="d-flex h-100 flex-column justify-content-center storyCnt">
                      <h2>Downloadable Memories</h2>
                      <p className="mb-1 ps-0">
                        Sharing a life legacy for generations to come.
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
        </section>
        {/* About Section End */}

        {/* lankmark section */}
        <section
          className={`landmarkSec d-block d-lg-flex justify-content-between ${isActive ? "active" : ""
            }`}
        >
          <div
            className="landmarkSec_left"
            style={{ paddingLeft: leftPadding }}
          >
            <div className="commonHead">
              <div className="commonHead_sub text-white">
                Click an image to view a timeless memory
              </div>
              <h2 className="commonHead_title text-white">
                Lifetime Journey
              </h2>
            </div>
            <div className="landmarkSec_box">
              <div className="landmarkSec_box-inner position-relative">
                <Card className="position-relative border-0 rounded-0">
                  <Link className="closeBtn" onClick={handleClose}>
                    <em className="icon-close" />
                  </Link>
                  <Card.Header className="bg-white">
                    <div className="profileImg d-flex align-items-center">
                      <ImageElement
                        className="img-fluid w-100 h-100 object-fit-cover"
                        source="theme01/map-detail.webp"
                      />
                    </div>
                  </Card.Header>
                  <Card.Body className="bg-white">
                    <span className="d-block date">Feb 20, 2023</span>
                    <h3>Friendship Saga, Journeying Through Bonds</h3>
                    <span className="d-block location">
                      <em className="icon-location me-1" />
                      San Francisco, CL
                    </span>
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled .
                    </p>
                  </Card.Body>
                  <Card.Footer className="bg-white d-flex justify-content-between align-items-end count">
                    <div className="me-1 count_txt">
                      <span>1 </span>/ 12
                    </div>
                    <div className="flex-shrink-0">
                      <RippleEffect>
                        <Button
                          type="button"
                          className="btn btn-light count_btn me-2 me-lg-3"
                        >
                          <em className="icon-arrow-right count_btn_arrowLeft" />
                        </Button>
                      </RippleEffect>
                      <RippleEffect>
                        <Button
                          type="button"
                          className="btn btn-danger count_btn"
                        >
                          <em className="icon-arrow-right" />
                        </Button>
                      </RippleEffect>
                    </div>
                  </Card.Footer>
                </Card>
              </div>
            </div>
          </div>
          <div className="landmarkSec_right" onClick={toggleClass}>
            <div className="mapOverlay" />
            <ImageElement
              className="img-fluid w-100 h-100 object-fit-cover"
              source="theme01/landmark.webp"
            />
          </div>
        </section>
        {/* lankmark section */}

        {/* captured section */}
        <section className="captured py-80" id="gallery">
          <Container>
            <div className="commonHead text-center">
              <div className="commonHead_sub">
                Photographs- Videos- Other Media
              </div>
              <h2 className="commonHead_title">Captured Memories </h2>
            </div>
            <div className="captured_inner">
              <Row className="gy-3 gy-lg-4">
                <Col xs={6} sm={4} md={3} lg={3}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_inner">
                      <div className="box_img">
                        <ImageElement
                          className="object-fit-cover w-100 h-100"
                          source="theme01/captured-01.webp"
                        />
                      </div>
                    </div>
                    <h4 className="text-center">The Early Years</h4>
                  </div>
                </Col>
                <Col xs={6} sm={4} md={3} lg={3}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_inner">
                      <div className="box_img">
                        <ImageElement
                          className="object-fit-cover w-100 h-100"
                          source="theme01/captured-02.webp"
                        />
                      </div>
                    </div>
                    <h4 className="text-center">Footprints of Time</h4>
                  </div>
                </Col>
                <Col xs={6} sm={4} md={3} lg={3}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_inner">
                      <div className="box_img">
                        <ImageElement
                          className="object-fit-cover w-100 h-100"
                          source="theme01/captured-03.webp"
                        />
                      </div>
                    </div>
                    <h4 className="text-center">Milestones Unfold</h4>
                  </div>
                </Col>
                <Col xs={6} sm={4} md={3} lg={3}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_inner">
                      <div className="box_img">
                        <ImageElement
                          className="object-fit-cover w-100 h-100"
                          source="theme01/captured-04.webp"
                        />
                      </div>
                    </div>
                    <h4 className="text-center">Family Bonds</h4>
                  </div>
                </Col>
                <Col xs={6} sm={4} md={3} lg={3}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_inner">
                      <div className="box_img">
                        <ImageElement
                          className="object-fit-cover w-100 h-100"
                          source="theme01/captured-05.webp"
                        />
                      </div>
                    </div>
                    <h4 className="text-center">Friendship Chronicles</h4>
                  </div>
                </Col>
                <Col xs={6} sm={4} md={3} lg={3}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_inner">
                      <div className="box_img">
                        <ImageElement
                          className="object-fit-cover w-100 h-100"
                          source="theme01/captured-06.webp"
                        />
                      </div>
                    </div>
                    <h4 className="text-center">Love & Relationships</h4>
                  </div>
                </Col>
                <Col xs={6} sm={4} md={3} lg={3}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_inner">
                      <div className="box_img">
                        <ImageElement
                          className="object-fit-cover w-100 h-100"
                          source="theme01/captured-07.webp"
                        />
                      </div>
                    </div>
                    <h4 className="text-center">Special Occasions</h4>
                  </div>
                </Col>
                <Col xs={6} sm={4} md={3} lg={3}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_inner">
                      <div className="box_img">
                        <ImageElement
                          className="object-fit-cover w-100 h-100"
                          source="theme01/captured-08.webp"
                        />
                      </div>
                    </div>
                    <h4 className="text-center">Home Sweet Home</h4>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
        {/* captured section */}

        {/* Timeline Section Start */}
        <section
          className="timelineSec position-relative py-80 overflow-hidden"
          id="timeline"
        >
          <Container>
            <div className="commonHead">
              <div className="commonHead_sub">Chronicles of a Life</div>
              <h2 className="commonHead_title">
                A Timeline of Timeless Memories
              </h2>
            </div>
          </Container>

          {/* timeline */}
          <div className="timelineSec_inner position-relative">
            <Container fluid>
              <div className="slider">
                <Swiper
                  spaceBetween={130}
                  slidesPerView={2}
                  loop
                  speed={1000}
                  autoplay={{
                    delay: 2500,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                  }}
                  grabCursor="true"
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                      spaceBetween: 100,
                    },
                    400: {
                      slidesPerView: 2,
                      spaceBetween: 60,
                    },
                    576: {
                      slidesPerView: 3,
                      spaceBetween: 100,
                    },
                    992: {
                      slidesPerView: 4,
                      spaceBetween: 130,
                    },
                    1200: {
                      slidesPerView: 5,
                    },
                    1399: {
                      slidesPerView: 5,
                    },
                    1599: {
                      slidesPerView: 6,
                    },
                  }}
                  modules={[Autoplay]}
                >
                  <SwiperSlide className="timeLine timeLine-sm text-center position-relative">
                    <div className="timeLine_img mx-auto timeLine_img-pdf">
                      <div className="box h-100">
                        <Link to="#" className="timeLine_img_icon">
                          <em className="icon-pdf" />
                          {/* <ImageElement
                        source="theme01/timeline-07.webp"
                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                        alt="timeline-img"
                      /> */}
                        </Link>
                        <h3 className="timeLine_img_txt mb-0">
                          Margarita & Ronnie wedding year
                        </h3>
                      </div>
                    </div>
                    <div className="timeLine_year">Nov 18, 2010</div>
                    <div className="borderTop" />
                    <div className="timeLine_circle position-absolute">
                      <span className="d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="timeLine  text-center position-relative">
                    <div
                      className="timeLine_img mx-auto"
                      onClick={() => openImageModal()}
                    >
                      <ImageElement
                        source="theme01/timeline-08.webp"
                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                        alt="timeline-img"
                      />
                      <h3 className="timeLine_img_txt mb-0">
                        Margarita & Ronnie wedding year
                      </h3>
                    </div>
                    <div className="timeLine_year">Sep 18, 2010</div>
                    <div className="borderTop" />
                    <div className="timeLine_circle position-absolute">
                      <span className="d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="timeLine timeLine-lg text-center position-relative">
                    <div className="timeLine_img mx-auto  timeLine_img-audio">
                      <div className="box h-100">
                        <span className="timeLine_img_icon">
                          <em className="icon-mic" />
                        </span>
                        {/* <ImageElement
                          source="theme01/timeline-09.webp"
                          className="w-100 h-100 object-fit-cover z-1 position-relative"
                          alt="timeline-img"
                        /> */}
                        <h3 className="timeLine_img_txt mb-0">
                          Margarita & Ronnie wedding year
                        </h3>
                      </div>
                    </div>
                    <div className="timeLine_year">June 18, 2010</div>
                    <div className="borderTop timeLine_border-3" />
                    <div className="timeLine_circle position-absolute">
                      <span className="d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="timeLine text-center position-relative">
                    <div
                      className="timeLine_img mx-auto"
                      onClick={() => openImageModal()}
                    >
                      <ImageElement
                        source="theme01/timeline-06.webp"
                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                        alt="timeline-img"
                      />
                      <h3 className="timeLine_img_txt mb-0">
                        Margarita & Ronnie wedding year
                      </h3>
                    </div>
                    <div className="timeLine_year">Oct 11, 2024</div>
                    <div className="borderTop" />
                    <div className="timeLine_circle position-absolute">
                      <span className="d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="timeLine timeLine-sm text-center position-relative">
                    <div
                      className="timeLine_img mx-auto timeLine_img-video"
                      onClick={() => openImageModal()}
                    >
                      <ImageElement
                        source="theme01/timeline-05.webp"
                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                        alt="timeline-img"
                      />

                      <span className="timeLine_img_icon">
                        <em className="icon-video" />
                      </span>
                      <h3 className="timeLine_img_txt mb-0">
                        Margarita & Ronnie wedding year
                      </h3>
                    </div>
                    <div className="timeLine_year">Sep 11, 2024</div>
                    <div className="borderTop timeLine_border-1" />
                    <div className="timeLine_circle position-absolute">
                      <span className="d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="timeLine text-center position-relative">
                    <div
                      className="timeLine_img mx-auto"
                      onClick={() => openImageModal()}
                    >
                      <ImageElement
                        source="theme01/timeline-10.webp"
                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                        alt="timeline-img"
                      />
                      <h3 className="timeLine_img_txt mb-0">
                        Margarita & Ronnie wedding year
                      </h3>
                    </div>
                    <div className="timeLine_year">Feb 1, 2015</div>
                    <div className="borderTop" />
                    <div className="timeLine_circle position-absolute">
                      <span className="d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="timeLine timeLine-lg text-center position-relative">
                    <div
                      className="timeLine_img mx-auto"
                      onClick={() => openImageModal()}
                    >
                      <ImageElement
                        source="theme01/timeline-07.webp"
                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                        alt="timeline-img"
                      />
                      <h3 className="timeLine_img_txt mb-0">
                        Margarita & Ronnie wedding year
                      </h3>
                    </div>
                    <div className="timeLine_year">Dec 15, 2018</div>
                    <div className="borderTop" />
                    <div className="timeLine_circle position-absolute">
                      <span className="d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="timeLine  text-center position-relative">
                    <div
                      className="timeLine_img mx-auto"
                      onClick={() => openImageModal()}
                    >
                      <ImageElement
                        source="theme01/timeline-08.webp"
                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                        alt="timeline-img"
                      />
                      <h3 className="timeLine_img_txt mb-0">
                        Margarita & Ronnie wedding year
                      </h3>
                    </div>
                    <div className="timeLine_year">June 20, 2020</div>
                    <div className="borderTop" />
                    <div className="timeLine_circle position-absolute">
                      <span className="d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="timeLine timeLine-sm text-center position-relative">
                    <div
                      className="timeLine_img mx-auto"
                      onClick={() => openImageModal()}
                    >
                      <ImageElement
                        source="theme01/timeline-09.webp"
                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                        alt="timeline-img"
                      />
                      <h3 className="timeLine_img_txt mb-0">
                        Margarita & Ronnie wedding year
                      </h3>
                    </div>
                    <div className="timeLine_year">Sep 11, 2024</div>
                    <div className="borderTop timeLine_border-3" />
                    <div className="timeLine_circle position-absolute">
                      <span className="d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="timeLine  text-center position-relative">
                    <div
                      className="timeLine_img mx-auto"
                      onClick={() => openImageModal()}
                    >
                      <ImageElement
                        source="theme01/timeline-06.webp"
                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                        alt="timeline-img"
                      />
                      <h3 className="timeLine_img_txt mb-0">
                        Margarita & Ronnie wedding year
                      </h3>
                    </div>
                    <div className="timeLine_year">Dec 15, 2018</div>
                    <div className="borderTop" />
                    <div className="timeLine_circle position-absolute">
                      <span className="d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="timeLine  timeLine-lg  text-center position-relative">
                    <div
                      className="timeLine_img mx-auto"
                      onClick={() => openImageModal()}
                    >
                      <ImageElement
                        source="theme01/timeline-05.webp"
                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                        alt="timeline-img"
                      />
                      <h3 className="timeLine_img_txt mb-0">
                        Margarita & Ronnie wedding year
                      </h3>
                    </div>
                    <div className="timeLine_year">Nov 18, 2010</div>
                    <div className="borderTop timeLine_border-1" />
                    <div className="timeLine_circle position-absolute">
                      <span className="d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="timeLine text-center position-relative">
                    <div
                      className="timeLine_img mx-auto"
                      onClick={() => openImageModal()}
                    >
                      <ImageElement
                        source="theme01/timeline-09.webp"
                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                        alt="timeline-img"
                      />
                      <h3 className="timeLine_img_txt mb-0">
                        Margarita & Ronnie wedding year
                      </h3>
                    </div>
                    <div className="timeLine_year">Sep 11, 2024</div>
                    <div className="borderTop" />
                    <div className="timeLine_circle position-absolute">
                      <span className="d-block" />
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </Container>
          </div>
        </section>
        {/* Timeline Section End */}

        {/* testimonials section */}
        <section className="testimonials py-80" id="story">
          <Container>
            <div className="commonHead text-center">
              <div className="commonHead_sub">Heartfelt Reflections</div>
              <h2 className="commonHead_title">
                Memories of Margarita <br className="d-none d-lg-block" />
                R. Proffitt{" "}
              </h2>
              <div className="d-flex justify-content-center btnFlex">
                <RippleEffect>
                  <Link className="mt-2 mt-md-4 btn-outline-danger btn">
                    Pending Comments
                  </Link>
                </RippleEffect>
                <RippleEffect>
                  <CommonButton
                    variant="danger"
                    extraClassName=" mt-2 mt-md-4"
                    onClick={() => setCommentModal(true)}
                  >
                    Share A Story
                  </CommonButton>
                </RippleEffect>
              </div>
            </div>
            <div className="testimonials_inner">
              <div className="testimonials_col">
                <Card>
                  <Card.Header>
                    <div className="profile d-flex align-items-center">
                      <ImageElement
                        className="img-fluid"
                        source="testimonial-01.webp"
                      />
                      <div className="profile_text">
                        <h3>Cheryl M. Martin</h3>
                        <p className="mb-0">
                          <em className="icon-location me-1" />
                          San Francisco, CL
                        </p>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book. It has survived not only five
                      centuries, but also the leap into electronic typesetting,
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>
                    <ImageElement
                      className="img-fluid img"
                      source="theme01/collection-01.webp"
                    />
                  </Card.Footer>
                </Card>
              </div>

              <div className="testimonials_col">
                <Card>
                  <Card.Header>
                    <div className="profile d-flex align-items-center">
                      <ImageElement
                        className="img-fluid"
                        source="testimonial-04.webp"
                      />
                      <div className="profile_text">
                        <h3>Aaron J. Lujan</h3>
                        <p className="mb-0">
                          <em className="icon-location me-1" />
                          San Francisco, CL
                        </p>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>
                      It is a long established fact that a reader will be
                      distracted by the readable content of a page when looking
                      at its layout.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>

              <div className="testimonials_col">
                <Card>
                  <Card.Header>
                    <div className="profile d-flex align-items-center">
                      <ImageElement
                        className="img-fluid"
                        source="testimonial-07.webp"
                      />
                      <div className="profile_text">
                        <h3>Thomas D. Reasoner</h3>
                        <p className="mb-0">
                          <em className="icon-location me-1" />
                          San Francisco, CL
                        </p>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>
                      Many desktop publishing packages and web page editors now
                      use Lorem Ipsum as their default model text, and a search
                      for 'lorem ipsum' will uncover many web sites still in
                      their infancy. Various versions have evolved over the
                      years, sometimes by accident, sometimes on purpose
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>

              <div className="testimonials_col">
                <Card>
                  <Card.Header>
                    <div className="profile d-flex align-items-center">
                      <ImageElement
                        className="img-fluid"
                        source="testimonial-02.webp"
                      />
                      <div className="profile_text">
                        <h3>Dyan G. Guerrette</h3>
                        <p className="mb-0">
                          <em className="icon-location me-1" />
                          San Francisco, CL
                        </p>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text Lorem Ipsum is simply .
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>
                    <Link href="#" className="w-100 pdf">
                      <ImageElement className="img-fluid" source="pdf.png" />
                      lorem ipsum text.pdf
                    </Link>
                  </Card.Footer>
                </Card>
              </div>

              <div className="testimonials_col">
                <Card>
                  <Card.Header>
                    <div className="profile d-flex align-items-center">
                      <ImageElement
                        className="img-fluid"
                        source="testimonial-05.webp"
                      />
                      <div className="profile_text">
                        <h3>Jerrold B. Hurd</h3>
                        <p className="mb-0">
                          <em className="icon-location me-1" />
                          San Francisco, CL
                        </p>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book. It has survived not only five
                      centuries, but also the leap into electronic
                      typesetting,but also the leap into electronic typesetting,
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>

              <div className="testimonials_col">
                <Card>
                  <Card.Header>
                    <div className="profile d-flex align-items-center">
                      <ImageElement
                        className="img-fluid"
                        source="testimonial-08.webp"
                      />
                      <div className="profile_text">
                        <h3>Cindy E. Thomas</h3>
                        <p className="mb-0">
                          <em className="icon-location me-1" />
                          San Francisco, CL
                        </p>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>
                      Many desktop publishing packages and web page editors now
                      use Lorem Ipsum as their default model text, and a search
                      for 'lorem ipsum' will uncover many web sites still in
                      their infancy. It has survived not only five centuries.
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>
                    <Link href="#" className="w-100 pdf">
                      <ImageElement className="img-fluid" source="pdf.png" />
                      lorem ipsum text.pdf
                    </Link>
                  </Card.Footer>
                </Card>
              </div>

              <div className="testimonials_col">
                <Card>
                  <Card.Header>
                    <div className="profile d-flex align-items-center">
                      <ImageElement
                        className="img-fluid"
                        source="testimonial-03.webp"
                      />
                      <div className="profile_text">
                        <h3>Elva G. Tucker</h3>
                        <p className="mb-0">
                          <em className="icon-location me-1" />
                          San Francisco, CL
                        </p>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took .
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>
                    <ImageElement
                      className="img-fluid img"
                      source="theme01/collection-02.webp"
                    />
                  </Card.Footer>
                </Card>
              </div>

              <div className="testimonials_col">
                <Card>
                  <Card.Header>
                    <div className="profile d-flex align-items-center">
                      <ImageElement
                        className="img-fluid"
                        source="testimonial-06.webp"
                      />
                      <div className="profile_text">
                        <h3>Julie J. Creed</h3>
                        <p className="mb-0">
                          <em className="icon-location me-1" />
                          San Francisco, CL
                        </p>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>
                      Many desktop publishing packages and web page editors now
                      use Lorem Ipsum as their default model text, and a search
                      editors now use Lorem Ipsum as their default model text,
                      and a search
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>

              <div className="testimonials_col">
                <Card>
                  <Card.Header>
                    <div className="profile d-flex align-items-center">
                      <ImageElement
                        className="img-fluid"
                        source="testimonial-09.webp"
                      />
                      <div className="profile_text">
                        <h3>James J. Sweat</h3>
                        <p className="mb-0">
                          <em className="icon-location me-1" />
                          San Francisco, CL
                        </p>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book. It has survived not only five
                      centuries.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </div>
            <RippleEffect extraClassName="justify-content-center mt-sm-3 w-100">
              <CommonButton variant="light">Load More</CommonButton>
            </RippleEffect>
          </Container>
        </section>
        {/* testimonials section */}

        {/* family tree section */}
        <section
          className={` familyTree py-80 ${isFullscreen ? "fullWidth" : ""}`}
          id="familytree"
        >
          <div className="familyTreeContainer mx-auto">
            <div className="commonHead text-center">
              <div className="commonHead_sub text-white">
                The Legacy Lives On
              </div>
              <h2 className="commonHead_title text-white">Our Family Tree</h2>
            </div>
            <div className="familyTreeContainer mx-auto">

              <div className="tree">
                <ul className="tree_inner">
                  <li className="parent" >
                    <div className="d-flex align-items-end parentsWrap  justify-content-center">
                      <div className="spouseParents">
                        <div className="d-flex align-items-end grandParents flex-row-reverse justify-content-center">
                          <div className="grandParents_item">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="grandParents_item ">
                            <a href="#!" className="spouse multipleParents">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <ul className="multipleParents">
                          <li className="child">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user27.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user12.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="mainParents">
                        <div className="d-flex align-items-end grandParents flex-row-reverse justify-content-center">
                          <div className="grandParents_item">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="grandParents_item ">
                            <a href="#!" className="spouse multipleParents">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <ul className="multipleParents">
                          <li className="child">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user15.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user16.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <ul>
                      <li className="child">
                        <Link className="spouse">
                          <div className="familyCard">
                            <div className="familyCard_img">
                              {/* <div className="familyCard_tag" >Parents</div> */}
                              <ImageElement
                                className="img-fluid"
                                source="family-tree/user06.jpg"
                              />
                              <span className="d-flex align-items-center justify-content-center position-absolute">
                                <em className="icon-info" />
                              </span>
                            </div>
                            <div className="familyCard_cnt">
                              <h2>Mother</h2>
                              <p>June 15, 1985 </p>
                              <p>Elder Brother</p>
                            </div>
                          </div>
                        </Link>
                        <Link>
                          <div className="heart d-flex align-items-center justify-content-center position-absolute">
                            <em className="icon-heart" />
                          </div>
                          <div className="familyCard">
                            <div className="familyCard_img">
                              <ImageElement
                                className="img-fluid"
                                source="family-tree/user03.jpg"
                              />
                              <span className="d-flex align-items-center justify-content-center position-absolute">
                                <em className="icon-info" />
                              </span>
                            </div>
                            <div className="familyCard_cnt">
                              <h2>Father</h2>
                              <p>May 11, 1988 </p>
                              <p>Brother's Wife</p>
                            </div>
                          </div>
                        </Link>
                        <ul className="multipleParents bottom">
                          <li className="child">
                            <Link className="pe-none">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user09.jpg"
                                  />
                                  {/* <span className="d-flex align-items-center justify-content-center position-absolute">
                                        <em className="icon-info" />
                                      </span> */}
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>Me </h2>
                                  <p>January 11, 2020 </p>
                                  <p>Brother's Son</p>
                                </div>
                              </div>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div className="controls">
                  <button onClick={fitToScreen}>
                    <em className="icon-screenfit" />
                  </button>
                  <button onClick={zoomIn}>
                    <em className="icon-plus" />
                  </button>
                  <button onClick={zoomOut}>
                    <em className="icon-minus" />
                  </button>
                  <button onClick={toggleFullscreen}>
                    <em className="icon-treeexpand" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* family tree section */}
      </main>
      {/* Image modal */}
      <ModalComponent
        // modalHeader="Image Slider"
        size="md"
        show={showModal}
        onHandleCancel={handleCloseModal}
        extraClassName="imageSlider imageSlider-img"
        backdropClassName="sliderBack"
        closeVariant="white"
      >
        <Container>
          <div className="slider_content slider">
            <h2>The Early Years</h2>
            <h3>Feb 1993</h3>
            <p className="mb-md-4 mb-3">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </p>
            <ImageElement
              className="img-fluid slider_img"
              source="theme01/slider-img-01.webp"
            />
          </div>
        </Container>
      </ModalComponent>

      {/* Image modal slider */}
      <ModalComponent
        // modalHeader="Image Slider"
        size="md"
        show={showModal1}
        onHandleCancel={handleCloseModal1}
        extraClassName="imageSlider"
        backdropClassName="sliderBack"
        pagination={{ clickable: true }}
        closeVariant="white"
      >
        <div className="slider">
          <h2 className="text-center">The Early Years</h2>
          <Swiper
            spaceBetween={20}
            slidesPerView={1.4}
            centeredSlides
            autoplay={{
              delay: 2500,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }}
            loop
            pagination={{
              clickable: true,
            }}
            navigation={{
              nextEl: ".next",
              prevEl: ".prev",
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              575: {
                slidesPerView: 1.3,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 1.4,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 1.4,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 1.8,
                spaceBetween: 20,
              },
            }}
            modules={[Autoplay, Pagination, Navigation]}
          >
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>The Early Years</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Footprints of Time</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Milestones Unfold</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-03.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Family Bonds</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Friendship Chronicles</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Love & Relationships</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-03.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Special Occasions</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Home Sweet Home</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Home Sweet Home</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Home Sweet Home</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
              />
            </SwiperSlide>
          </Swiper>
          <div className="slider_btn">
            <Button type="button" className="prev">
              <em className="icon-left-arrow" />
            </Button>
            <Button type="button" className="next">
              <em className="icon-right-arrow" />
            </Button>
          </div>
        </div>
      </ModalComponent>

      {/* Share Biography Modal */}
      <ModalComponent
        show={shareModal}
        size="md"
        title="Share Biography"
        closeButton="true"
        modalExtraClass="sharebiography"
        extraTitleClassName="sharebiography_title"
        onHandleCancel={handleCloseModalShare}
      >
        <div className="sharebiography_body">
          <form>
            <div className="d-flex align-items-end lh-1">
              <div className="form-group mb-0">
                <label className="form-label lh-sm">Copy Url</label>
                <input
                  id="url"
                  name="url"
                  className="form-control"
                  placeholder="Enter Url"
                  type="email"
                />
              </div>
              <RippleEffect>
                <Button variant="danger">Copy Link</Button>
              </RippleEffect>
            </div>
          </form>
        </div>
        <div className="sharebiography_footer">
          <h3>Share this link via</h3>
          <ul className="d-flex list-unstyled mb-0">
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
              >
                <em className="icon-instagram" />
              </Link>
            </li>
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
              >
                <em className="icon-twitter" />
              </Link>
            </li>
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
              >
                <em className="icon-youtube" />
              </Link>
            </li>
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
              >
                <em className="icon-facebook" />
              </Link>
            </li>
          </ul>
        </div>
      </ModalComponent>

      {/* Add Comment Modal */}
      <ModalComponent
        show={commentModal}
        size="md"
        title="Write Comment"
        closeButton="true"
        modalExtraClass="commentModel"
        extraTitleClassName="commentModel_title"
        onHandleCancel={handleCloseModalComment}
      >
        <div className="commentModel_body">
          <form>
            <div className="d-sm-flex w-100">
              <div className="commentModel_left">
                <h2>Upload Picture/ pdf</h2>
                <div className="customUpload customUpload-icon customUpload-w100">
                  <Upload listType="picture-card" className="avatar-uploader">
                    <div>
                      <em className="icon-upload" />
                      <span className="d-block">Upload Picture/ Pdf</span>
                    </div>
                  </Upload>
                </div>
              </div>
              <div className="commentModel_right w-100">
                <h2>Comment</h2>
                <Row className="g-20">
                  {/* <Col xs={12}>
                    <div className="form-group mb-0">
                      <label className="form-label">Full Name</label>
                      <Input
                        id="faname"
                        name="faname"
                        className="form-control"
                        placeholder="Enter Full Name"
                        value="Cheryl M. Martin"
                        readOnly
                      />
                    </div>
                  </Col> */}
                  <Col xs={12}>
                    <div className="form-group">
                      {/* <label className="form-label">Comments</label> */}
                      <textarea
                        className="form-control form-control-textarea w-100"
                        placeholder="Type Here"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="commentModel_btn d-flex justify-content-end">
                  <RippleEffect>
                    <Button
                      className="btn btn-light"
                      onClick={() => setCommentModal(false)}
                    >
                      Close
                    </Button>
                  </RippleEffect>
                  <RippleEffect>
                    <Button
                      className="btn btn-danger"
                      onClick={() => setCommentModal(false)}
                    >
                      Send
                    </Button>
                  </RippleEffect>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ModalComponent>
      {/* Memories video modal */}
      <ModalComponent
        show={showVideoModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalVideo}
      >
        <form>
          <div className="videoModal_body">
            <div className="d-flex flex-wrap justify-content-between mb-sm-0 mb-3 w-100">
              <div className="commonSearch">
                <div className="form-group mb-0">
                  <div className="commonSearch_icn position-relative">
                    <input
                      id="serch"
                      name="serch"
                      className="form-control"
                      placeholder="Search Here"
                    />
                    <em className="icon-search position-absolute" />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <RippleEffect extraClassName="me-xl-2 me-1">
                  <Button
                    className="btn btn-light"
                    onClick={handleSelectAllVideo}
                  >
                    {selectAllCheckedVideo ? "Unselect All" : "Select All"}
                  </Button>
                </RippleEffect>
                <RippleEffect extraClassName="ms-md-1 ms-0">
                  <Button className="btn btn-danger">Download</Button>
                </RippleEffect>
              </div>
            </div>
            <Row>
              {videoMemories.map((el, index) => (
                <Col lg={4} sm={6} key={index}>
                  <Checkbox
                    checked={individualCheckboxesVideo[index]}
                    onChange={() => handleCheckboxChangeVideo(index)}
                  >
                    <div className="videoCard position-relative">
                      {el.imageShow ? (
                        <Link>
                          <ImageElement source={el.thumbnail} alt="video" />
                        </Link>
                      ) : (
                        <ImageElement source={el.thumbnail} alt="video" />
                      )}

                      <div className="videoCard_cnt d-flex justify-content-between align-items-center position-absolute w-100">
                        <h2 className="mb-0">{el.name}</h2>
                        {el.videoDuration && (
                          <span className="d-inline-block">{el.duration}</span>
                        )}
                      </div>
                      {el.videoIcon && (
                        <Link
                          to="#!"
                          className="videoCard_playbtn position-absolute"
                          onClick={() => handleVideoFullShow(true)}
                        >
                          <div className="videoCard_playbtn_inner d-flex align-items-center justify-content-center">
                            <em className="icon-video" />
                          </div>
                        </Link>
                      )}
                      {el.imageIcon && (
                        <Link
                          to="#!"
                          className="videoCard_viewbtn position-absolute"
                          onClick={() => handleImageFullShow(true)}
                        >
                          <div className="videoCard_viewbtn_inner d-flex align-items-center justify-content-center">
                            <em className="icon-eye" />
                          </div>
                        </Link>
                      )}
                    </div>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories audio modal */}
      <ModalComponent
        show={showAudioModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="audioModal"
        extraTitleClassName="audioModal_title"
        onHandleCancel={handleCloseModalAudio}
      >
        <form>
          <div className="audioModal_body">
            <div className="d-flex flex-wrap justify-content-between mb-sm-0 mb-3 w-100">
              <div className="commonSearch">
                <div className="form-group mb-0">
                  <div className="commonSearch_icn position-relative">
                    <input
                      id="serch"
                      name="serch"
                      className="form-control"
                      placeholder="Search Here"
                    />
                    <em className="icon-search position-absolute" />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <RippleEffect extraClassName="me-xl-2 me-1">
                  <Button
                    className="btn btn-light"
                    onClick={handleSelectAllAudio}
                  >
                    {selectAllCheckedAudio ? "Unselect All" : "Select All"}
                  </Button>
                </RippleEffect>
                <RippleEffect extraClassName="ms-md-1 ms-0">
                  <Button className="btn btn-danger">Download</Button>
                </RippleEffect>
              </div>
            </div>
            <Row>
              {audioMemories.map((el, index) => (
                <Col lg={4} sm={6} key={index}>
                  <Checkbox
                    checked={individualCheckboxesAudio[index]}
                    onChange={() => handleCheckboxChangeAudio(index)}
                  >
                    <div className="audioCard position-relative">
                      <div className="d-flex align-items-center">
                        <Link
                          to="#!"
                          className="audioCard_icon d-flex justify-content-center align-items-center"
                        >
                          <em className="icon-video" />
                        </Link>
                        <div className="w-100">
                          <h3>{el.name}</h3>
                          <div className="audioCard_img d-flex align-items-center">
                            <ImageElement
                              source="audio.svg"
                              alt="audio"
                              className="w-100"
                            />
                            <span>{el.duration}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories video Full modal */}
      <ModalComponent
        show={showVideoFullModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalVideoFull}
      >
        <form>
          <div className="videoModal_body">
            <Row>
              <Col sm={12}>
                <div className="videoCard-full position-relative overflow-hidden">
                  <ImageElement
                    source="modal-video-01.webp"
                    alt="video"
                    className="h-100 w-100 object-fit-cover"
                  />
                  <Link to="#!" className="videoCard_playbtn position-absolute">
                    <div className="videoCard_playbtn_inner d-flex align-items-center justify-content-center">
                      <em className="icon-video" />
                    </div>
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories image Full modal */}
      <ModalComponent
        show={showImageFullModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalImageFull}
      >
        <form>
          <div className="videoModal_body">
            <Row>
              <Col sm={12}>
                <div className="videoCard-full position-relative overflow-hidden">
                  <ImageElement
                    source="modal-video-01.webp"
                    alt="video"
                    className="h-100 w-100 object-fit-cover"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories Pdf modal */}
      <ModalComponent
        show={showPdfModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalPdf}
      >
        <form>
          <div className="videoModal_body">
            <div className="d-flex flex-wrap justify-content-between mb-sm-0 mb-3 w-100">
              <div className="commonSearch">
                <div className="form-group mb-0">
                  <div className="commonSearch_icn position-relative">
                    <input
                      id="serch"
                      name="serch"
                      className="form-control"
                      placeholder="Search Here"
                    />
                    <em className="icon-search position-absolute" />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <RippleEffect extraClassName="me-xl-2 me-1">
                  <Button className="btn btn-light" onClick={handleSelectAll}>
                    {selectAllChecked ? "Unselect All" : "Select All"}
                  </Button>
                </RippleEffect>
                <RippleEffect extraClassName="ms-md-1 ms-0">
                  <Button className="btn btn-danger">Download</Button>
                </RippleEffect>
              </div>
            </div>
            <Row>
              {[0, 1, 2, 3, 4, 5].map((index) => (
                <Col lg={4} sm={6} key={index}>
                  <Checkbox
                    checked={individualCheckboxes[index]}
                    onChange={() => handleCheckboxChange(index)}
                  >
                    <div className="pdfCard position-relative d-flex align-items-center justify-content-center flex-column">
                      <ImageElement
                        source="theme03/pdf-white.webp"
                        alt="logo"
                      />
                      <Link className="viewBtn">View PDF</Link>
                    </div>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Report modal */}
      <ModalComponent
        show={showReportModal}
        size="md"
        title="Report Biography"
        closeButton="true"
        modalExtraClass="reportModal"
        extraTitleClassName="reportModal_title"
        onHandleCancel={handleCloseModalReport}
      >
        <form>
          <div className="reportModal_body">
            {/* <h2>Are you sure to want to report this?</h2> */}
            <div className="form-group">
              <label className="form-label lh-sm">Category</label>
              <Select
                placeholder="Select Reason"
                options={[
                  { value: "Category01", label: "Category01" },
                  { value: "Category02", label: "Category02" },
                  { value: "Category03", label: "Category03" },
                ]}
              />
            </div>
            <div className="form-group mb-0">
              <label className="form-label lh-sm">Reason for Report</label>
              <textarea
                className="form-control form-control-textarea"
                placeholder="Type Here"
              />
            </div>
          </div>
          <div className="reportModal_footer text-end">
            <RippleEffect>
              <Button
                className="btn btn-light"
                onClick={() => setReportModal(false)}
              >
                Close
              </Button>
            </RippleEffect>
            <RippleEffect>
              <Button
                className="btn btn-danger"
                onClick={() => setReportModal(false)}
              >
                Send Report
              </Button>
            </RippleEffect>
          </div>
        </form>
      </ModalComponent>
    </>
  );
}

export default Theme01;
